const Photo = ({photoProfile}) => {
    return(
        <div className="relative group">
            {/* Decorative background elements */}
            <div className="absolute -inset-4 bg-gradient-to-r from-blue-400 via-purple-400 to-indigo-400 rounded-full opacity-20 group-hover:opacity-30 transition-opacity duration-500 animate-pulse"></div>
            <div className="absolute -inset-2 bg-gradient-to-r from-blue-500 to-indigo-500 rounded-full opacity-10 group-hover:opacity-20 transition-opacity duration-500"></div>
            
            {/* Main photo container */}
            <div className="relative w-80 h-80 lg:w-96 lg:h-96 xl:w-[450px] xl:h-[450px]">
                <img 
                    className="w-full h-full object-cover rounded-full shadow-2xl ring-4 ring-white ring-opacity-50 transition-all duration-500 group-hover:scale-105 group-hover:shadow-3xl" 
                    src={photoProfile} 
                    alt="profile photo"
                />
                
                {/* Floating accent dots */}
                <div className="absolute -top-2 -right-2 w-4 h-4 bg-blue-400 rounded-full animate-bounce opacity-70"></div>
                <div className="absolute -bottom-4 -left-4 w-6 h-6 bg-indigo-400 rounded-full animate-pulse opacity-60"></div>
                <div className="absolute top-1/2 -left-6 w-3 h-3 bg-purple-400 rounded-full animate-ping opacity-50"></div>
            </div>
        </div>
    )
}
export default Photo;